import { Step } from 'signup-constants/Step';
import { ExperimentKeys } from '../../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../../experiments/ExperimentParameterGroup';
import { getIsActiveAndAssignedToVariant } from '../../store/experiments/selectors';
import { isPreVerification } from '../../flow-settings/settingsSelectors';
import { getIsExistingUserSession } from '../../store/app/selectors';
import { setFlowForCOAC0001 } from '../../experiments/coac-0001/COAC001Utils';
export const BranchCOAC0001 = {
  name: 'BranchCOAC0001',
  stateCheck: state => {
    return getIsActiveAndAssignedToVariant(state, ExperimentKeys.COAC0001, [ExperimentParameterGroup.Variant_A, ExperimentParameterGroup.Variant_B]);
  },
  rebuildFlow: (flow, state, dispatch) => {
    const nextSteps = dispatch(setFlowForCOAC0001({
      isPreVerificationExistingUserSession: getIsExistingUserSession(state) && isPreVerification()
    }));
    return nextSteps;
  },
  processed: false,
  processedOnStep: Step.LandingPage,
  afterData: null,
  afterStep: null
};